/**
 * 公司 API — GET /api/companies。
 */
import client from "./client";
import type { Company } from "../types";

/** 获取公司列表。 */
export async function getCompanies(): Promise<Company[]> {
  return client.get<unknown, Company[]>("/companies");
}

/** 获取公司详情。 */
export async function getCompany(companyId: string): Promise<Company> {
  return client.get<unknown, Company>(`/companies/${companyId}`);
}
